export default function changeLimits(params) {
    this.popup('portalChangeLimits', {params: params});
}
